import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';

const AddCustomer2Modal = ({ open, onClose, onCreated, loading = false }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [description, setDescription] = useState('');
  const [paymentTerms, setPaymentTerms] = useState('');
  const [saleId, setSaleId] = useState('');

  const handleSubmit = e => {
    e.preventDefault();
    onCreated({ name, phone, description, paymentTerms: paymentTerms.split(',').map(s => s.trim()).filter(Boolean), saleId });
    setName(''); setPhone(''); setDescription(''); setPaymentTerms(''); setSaleId('');
  };

  return (
    <Modal show={open} onHide={onClose} centered backdrop={loading ? 'static' : true}>
      <form onSubmit={handleSubmit}>
        <Modal.Header closeButton={!loading}>
          <Modal.Title>Add Customer 2</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="mb-3">
            <label className="form-label">Name</label>
            <input className="form-control" value={name} onChange={e => setName(e.target.value)} disabled={loading} />
          </div>
          <div className="mb-3">
            <label className="form-label">Phone</label>
            <input className="form-control" value={phone} onChange={e => setPhone(e.target.value)} disabled={loading} />
          </div>
          <div className="mb-3">
            <label className="form-label">Description</label>
            <input className="form-control" value={description} onChange={e => setDescription(e.target.value)} disabled={loading} />
          </div>
          <div className="mb-3">
            <label className="form-label">Payment Terms (comma-separated dates)</label>
            <input className="form-control" value={paymentTerms} onChange={e => setPaymentTerms(e.target.value)} disabled={loading} />
          </div>
          <div className="mb-3">
            <label className="form-label">Sale ID</label>
            <input className="form-control" value={saleId} onChange={e => setSaleId(e.target.value)} disabled={loading} />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose} disabled={loading}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Create'}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default AddCustomer2Modal; 